import {
  Button,
  Form,
  PageHeader,
  Row,
  Breadcrumb,
  Popconfirm,
  Col,
  Input,
  message,
  Spin,
} from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { materialTypeService } from "_services/materialttype.service";

const BomUpload = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [base64File, setBase64File] = useState(null);
  const [originalFileName, setOriginalFileName] = useState(null);
  const [error, setError] = useState(null);

  const [form] = Form.useForm();

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        const payload = {
          productName: values.productName,
          productCode: values.productCode,
          companyCode: values.companyCode,
          base64FileString: base64File,
          originalFileName: originalFileName,
        };

        materialTypeService
          .uploadBomFile(payload)
          .then(() => {
            message.success("Successfully uploaded!");
            setIsLoading(false);
            history.push("/bom/boms");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push("/bom/boms");
  };

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setOriginalFileName(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function (e) {
        setBase64File(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Button
        onClick={handleFormSumbit}
        key="upload"
        type="primary"
        htmlType="submit"
        loading={isLoading}
      >
        Upload
      </Button>
    );
    buttons.push(
      <Button key="cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/bom/boms">BOM</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>BOM File Upload</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={12}>
                <Col span={6}>
                  <Form.Item
                    name="productCode"
                    label="HS Code / Finished Product"
                    rules={[{ required: true, message: "HS Code Is Required" }]}
                  >
                    <Input placeholder="HS Code" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="companyCode"
                    label="Product Code"
                    rules={[
                      { required: true, message: "Product Code Is Required" },
                    ]}
                  >
                    <Input placeholder="Product Code" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    name="productName"
                    label="Product Name"
                    rules={[
                      { required: true, message: "Product Name Is Required" },
                    ]}
                  >
                    <Input placeholder="Product Name" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="file"
                    label="BOM file upload"
                    rules={[
                      {
                        required: true,
                        message: "Valid Excel file is required",
                      },
                    ]}
                    valuePropName="file"
                  >
                    <Input
                      type="file"
                      name="file"
                      onChange={onFileChange}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={18}></Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
};

export default BomUpload;
